import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import { mockCarePlanData } from './mockCarePlanData'

const EATING_AND_DRINKING_ADL = '5d3ef8e7610ca2e6713c60f0'

export const useGetCarePlanFluidIntake = (
  residentID: string,
  fluidTrackingFlagEnabled: boolean,
  mock = false
) => {
  const { isLoading, data, refetch } = useQuery(
    ['care-plan-fluid-intake', residentID],
    () => getJSON({ url: getListQuery(residentID) }),
    {
      enabled: fluidTrackingFlagEnabled && !mock
    }
  )

  if (mock) {
    return {
      carePlanData: mockCarePlanData.data,
      isLoading: false,
      refetch: () => Promise.resolve()
    }
  }

  return {
    carePlanData: data?.data,
    isLoading,
    refetch
  }
}

const getListQuery = (residentId: string) =>
  `/api/list/residents/${residentId}/adls/${EATING_AND_DRINKING_ADL}/care-plan`
